module.exports = __webpack_public_path__ + "static/media/bgMerchandise.61bc63ea.png";